import React from "react";
import { Select, Space, Input } from "antd";

import { CARD_CHARGE_STATUSES } from "../../constants/cardBinding";

const CardChargeFilters = ({ filters, onFiltersChange }) => (
  <Space size="large" wrap>
    <div>
      <Input.Search
        addonBefore="Email"
        placeholder="Merchant email"
        allowClear
        style={{ width: 360 }}
        onSearch={(email) => onFiltersChange({ ...filters, email: email.trim() || undefined })}
        onChange={(event) => {
          if (!event.target.value && filters.email) onFiltersChange({ ...filters, email: undefined });
        }}
      />
    </div>

    <div>
      Status:{" "}
      <Select
        placeholder="ALL"
        style={{ width: 180 }}
        allowClear
        value={filters.status}
        onChange={(status) => onFiltersChange({ ...filters, status })}
      >
        {CARD_CHARGE_STATUSES.map((status) => (
          <Select.Option key={status} value={status}>
            {status}
          </Select.Option>
        ))}
      </Select>
    </div>
  </Space>
);

export default CardChargeFilters;
